
export interface MergeFieldOption {

	fromField: FieldDisplay | null;
	toField: FieldDisplay | null;
	fromCaseId: string | null;
	toCaseId: string | null;
	selectedCase: CaseSelection;
	fieldType: FieldType;
}

export interface MergeCaseFields {
	fieldSelections: FieldSelection[]
}

export interface FieldSelection {
	caseSelection : CaseSelection,
	fieldType: FieldType,
	fieldId: string
}

export enum CaseSelection {
	merge = 0,
	fromCase = 1,
	toCase = 2
}

export enum FieldType
{
	regular,
	global
}

export interface FieldDisplay {
	id: string,
	title: string;
	value: any;
	dataType: string;
	listItemType: string | null,
	valueObject: any,
	hasViewPermission: boolean,
	fieldType: FieldType,
}
